export const APP_NAME = "os2-web"
export const APP_DISPLAY_NAME = "OpenSea"

export const BUILD_ID = process.env.BUILD_ID || "development"

export const BUILD_TIMESTAMP =
  process.env.BUILD_TIMESTAMP || new Date().toISOString()

export const ENVIRONMENT = process.env.ENVIRONMENT || process.env.NODE_ENV

// This basically means if we are on the opensea.io website
export const IS_PRODUCTION = ENVIRONMENT === "prod-mainnet"

type LoggingLevel = "silent" | "trace" | "debug" | "info" | "warn" | "error"

export const LOG_LEVEL: LoggingLevel = process.env
  .NEXT_PUBLIC_LOG_LEVEL as LoggingLevel
